// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
import { Version, SerializableObject } from "./serialization";
export class HostCapabilities extends SerializableObject {
    constructor() {
        super(...arguments);
        this._capabilities = {};
    }
    getSchemaKey() {
        return "HostCapabilities";
    }
    internalParse(source, context) {
        super.internalParse(source, context);
        if (source) {
            // eslint-disable-next-line guard-for-in
            for (const name in source) {
                const jsonVersion = source[name];
                if (typeof jsonVersion === "string") {
                    if (jsonVersion === "*") {
                        this.addCapability(name, "*");
                    }
                    else {
                        const version = Version.parse(jsonVersion, context);
                        if (version === null || version === void 0 ? void 0 : version.isValid) {
                            this.addCapability(name, version);
                        }
                    }
                }
            }
        }
    }
    internalToJSON(target, context) {
        super.internalToJSON(target, context);
        // eslint-disable-next-line guard-for-in
        for (const key in this._capabilities) {
            target[key] = this._capabilities[key];
        }
    }
    addCapability(name, version) {
        this._capabilities[name] = version;
    }
    removeCapability(name) {
        delete this._capabilities[name];
    }
    clear() {
        this._capabilities = {};
    }
    hasCapability(name, version) {
        if (this._capabilities.hasOwnProperty(name)) {
            if (version === "*" || this._capabilities[name] === "*") {
                return true;
            }
            return version.compareTo(this._capabilities[name]) <= 0;
        }
        return false;
    }
    areAllMet(hostCapabilities) {
        for (const capabilityName in this._capabilities) {
            if (!hostCapabilities.hasCapability(capabilityName, this._capabilities[capabilityName])) {
                return false;
            }
        }
        return true;
    }
}
//# sourceMappingURL=host-capabilities.js.map